import { USE_QUERY_OPTIONS } from 'constants/config';
import { useMutation, useQuery } from 'react-query';

import userApi, { GetUserRequest } from 'services/users';
import { GET_USERS } from './keys';

export const useGetUsers = (params: GetUserRequest) =>
  useQuery([GET_USERS, params], () => userApi.getUsers(params), { ...USE_QUERY_OPTIONS });
export const useGetUser = (userId: string) =>
  useQuery(['getUser', userId], () => userApi.getUser(userId), {
    ...USE_QUERY_OPTIONS,
    select: ({ data }) => data,
    refetchOnMount: 'always',
  });
export const useSaveUser = () => useMutation(userApi.saveUser, { mutationKey: 'saveUser' });
export const useUpdateUserStatus = () => useMutation(userApi.updateUserStatus, { mutationKey: 'updateUserStatus' });
